// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const SECURITY_AREA_ID = 4;


class SecurityCorrelationsHeaderNav extends Component {

  renderPreviousLink() {
    const { areas, baseNavRoute } = this.props;
    const previousAreaId = SECURITY_AREA_ID;
    const previousArea = (areas || []).find(a => a.id === previousAreaId);

    if (previousArea) {
      return (
        <Link
          to={`${baseNavRoute}/goals/${previousArea.id}`}
          className='prev-link'
        >
          &#60; Previous: {previousArea.title}
        </Link>
      );
    }
  }

  renderNextLink() {
    const { areas, activeAreaIds, canEditUsage, baseNavRoute } = this.props;
    const nextAreaId = activeAreaIds && activeAreaIds[activeAreaIds.indexOf(4) + 1];
    const nextArea = (areas || []).find(a => a.id === nextAreaId);

    if (nextArea) {
      return (
        <Link
          to={`${baseNavRoute}/goals/${nextArea.id}`}
          className='next-link'
        >
          Next: {nextArea.title} &#62;
        </Link>
      );
    } else if (canEditUsage) {
      return (
        <Link
          to={`${baseNavRoute}/usage`}
          className='next-link'
        >
          Next: Usage &#62;
        </Link>
      );
    } else {
      return (
        <Link
          to={`${baseNavRoute}/sources`}
          className='next-link'
        >
          Next: Sources &#62;
        </Link>
      );
    }
  }

  render() {
    return (
      <div className='security-correlations-header'>
        <div className='next-prev-links'>
          {this.renderPreviousLink()}
          {this.renderNextLink()}
        </div>
      </div>
    );
  }
}

SecurityCorrelationsHeaderNav.propTypes = {
  areas: PropTypes.array,
  activeAreaIds: PropTypes.array,
  canEditUsage: PropTypes.bool.isRequired,
  baseNavRoute: PropTypes.string.isRequired
};

export default SecurityCorrelationsHeaderNav;


// WEBPACK FOOTER //
// ./src/components/correlations/SecurityCorrelationsHeaderNav.js